import thunk from 'redux-thunk'
import store from "../../store"
import axios from 'axios'
import { fetchEmployeesRequest, fetchEmployeesSuccess, fetchEmployeesFailed } from './actions'


export const fetchEmployees = (successCallback=()=>{} , errorCallback = ()=>{} ) => {
    return dispatch => {
        const state = store.getState()
        const {server} = state.entity
        const {token}  = state.auth.authData
        dispatch(fetchEmployeesRequest())
        axios.get(`${server}/user/get-all-employees/`,{headers:{Authorization:`Token ${token}`}})
        .then(
            response => {
                dispatch(fetchEmployeesSuccess(response.data))
                successCallback()
            }
        )
        .catch(
            error => {
                console.error(error)
                dispatch(fetchEmployeesFailed(error))
                errorCallback()
            }
      )
    }
}


